import { Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";

export const SeeTheListButton = ({ to, onClick, label }: { to: string; onClick?: () => void; label?: string }) => {
  const { t } = useTranslation();
  return (
    <Button as={RouterLink} to={to} onClick={onClick} size="md" minH="44px" variant="outline" colorScheme="teal" alignSelf="flex-start" mt="1">
      {label ?? t("See the list")}
    </Button>
  );
};
